/**
 * promo_landing_controller.js — demo landing page behaviour (/promo/landing) (Stimulus).
 *
 * Scoped to the promo landing content (data-controller="promo-landing"). Bundles the
 * two interactive behaviours the page used to wire with an inline onclick and an inline
 * <script> (both break after a Turbo <body> swap and are forbidden by the JS ratchet):
 *
 *   1. startDemo — submit feedback for the "Have a Play" form. The form keeps
 *      data-turbo="false" (a successful POST 302s into the authenticated dashboard
 *      shell, which has different tracked assets), so submit is a full navigation and
 *      the button stays in its "Setting up..." state until unload. Bound via
 *      data-action="submit->promo-landing#startDemo"; disabling the button inside the
 *      submit handler does NOT cancel the in-flight submission.
 *
 *   2. expand/collapse — flip the store-proposal chevron when its Bootstrap collapse
 *      opens/closes. Bound via data-action on the collapse element listening to
 *      show.bs.collapse / hide.bs.collapse. connect() syncs the icon if the section
 *      starts expanded.
 *
 * Targets: demoButton (the submit button), chevron (the collapse caret icon).
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
        static targets = ['demoButton', 'chevron'];

        connect() {
            var collapse = this.element.querySelector('#storeProposal');
            if (collapse && collapse.classList.contains('show')) this.expand();
        }

        startDemo() {
            if (!this.hasDemoButtonTarget) return;
            var btn = this.demoButtonTarget;
            btn.disabled = true;
            btn.innerHTML = '<i class="bi bi-hourglass-split me-2"></i>Setting up your demo...';
        }

        expand() {
            if (this.hasChevronTarget) this.chevronTarget.classList.replace('bi-chevron-down', 'bi-chevron-up');
        }

        collapse() {
            if (this.hasChevronTarget) this.chevronTarget.classList.replace('bi-chevron-up', 'bi-chevron-down');
        }
}
